<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import CountryFlag from './CountryFlag.vue'
import { userApi } from '@/services/api';

import { useUserStore } from '@/config/store/userStore'
const userStore = useUserStore()

withDefaults(defineProps<{
  size?: string
}>(), {
  size: 'w-6',
})

const { locale } = useI18n()

const changeLocal = () => {
  locale.value = locale.value === 'fr' ? 'en' : 'fr'
  if(userStore.user.user) {
    userApi.updateLocale(locale.value.toUpperCase())
    userStore.user.user.lang = locale.value.toUpperCase()
  }
}
const currentCountryImage = computed(() => {
  return `/flag_${locale.value === 'fr' ? 'FR' : 'EN'}.webp`
})
</script>

<template>
  <span title="Switch application language" class="tracking-wide cursor-pointer" @click="changeLocal">
    <slot name="prepend-text"></slot>
    <img :class="[size]" height="15" :src="currentCountryImage" alt="Office country" class="text-xl">
  </span>
</template>
